<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/jala-farm";

export default {
  extends: ModelCreate,
  page: {
    title: "Create JALA Farms",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_farms.singular')) }},
    resourceRoute: {default: 'jala_farms'},
    modelVariable: {default: 'jala_farm'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_farms.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_farms.plural')),
          href: "/jala_farms",
        },
        {
          text: this.$t("Create New"),
          href: "/jala_farms/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      if (value.jala_farm_id)
        return this.$axios.post('/jala/investor_farms', {
          farm_id: value.jala_farm_id
        })
      return this.$axios.post('/jala/farms', value);
    }
  }
}
</script>
